<div
  class="entry-item"
  [ngClass]="{
    last: lastItem,
    'no-stock-error': noStockError && item?.updateable,
    'low-stock-error': lowStockError && item?.updateable,
    'unapproved-error': unapprovedError && item?.unavailableInB2B
  }"
>
  <!-- Item Image -->
  @if (pageId === cartPageId) {
  <hr class="one" />
  } @if (pageId === cartPageId) {
  <hr class="two" />
  } @if (pageId === cartPageId) {
  <hr class="three" [ngClass]="isShimanoMemoEnabled$ | async" />
  }
  <div class="cart-image" [class.fish]="businessType === 'fish'">
    @if (pageId === cartPageId) {
    <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl" (click)="viewItem()">
      <ng-template [ngTemplateOutlet]="cartItemImage"></ng-template>
    </a>
    } @else {
    <img
      [alt]="
        pageId === cartPageId
          ? item?.product?.images?.PRIMARY?.product?.altText
          : item?.product?.images?.PRIMARY?.altText
      "
      [src]="
        getImageRendition(item?.product?.images?.PRIMARY)?.url ||
        getImageRendition(item?.product?.images ? item?.product?.images[0] : undefined)?.url
      "
      onerror="this.className='is-missing'"
    />
    }
    <ng-template #cartItemImage>
      <img
        [alt]="
          pageId === cartPageId
            ? item?.product?.images?.PRIMARY?.product?.altText
            : item?.product?.images?.PRIMARY?.altText
        "
        [src]="
          getImageRendition(item?.product?.images?.PRIMARY)?.url ||
          getImageRendition(item?.product?.images ? item?.product?.images[0] : undefined)?.url
        "
        onerror="this.className='is-missing'"
      />
    </ng-template>
  </div>
  <!-- Item Info -->
  <div class="desc">
    <!-- code -->
    @if (item?.product?.code) {
    <div class="product-code">
      <span>
        {{ item?.product?.code }}
      </span>
    </div>
    }
    <div class="stock-status">
      @if (pageId === cartPageId && !noStockError && item?.product?.stock?.stockLevelStatus === 'outOfStock') {
      <span class="no-stock">
        {{ 'product.noStock' | cxTranslate }}
      </span>
      } @if ( pageId === cartPageId && !noStockError && item?.product?.stock?.stockLevelStatus !== 'outOfStock' &&
      item?.product?.stock?.stockLevelStatus !== 'discontinued' && !isManualAllocationActive ) { @switch
      ((item?.product)['inStockFlag']) { @case (true) {
      <span class="in-stock">
        {{ 'product.inStock' | cxTranslate }}
      </span>
      } @case (false) {
      <span class="no-stock">
        {{ 'product.noStock' | cxTranslate }}
      </span>
      } } } @if ( isManualAllocationActive && item?.product?.stock?.stockLevelStatus !== 'discontinued' &&
      item?.product?.stock?.stockLevelStatus !== 'outOfStock' ) {
      <span class="no-stock"> {{ 'product.noStock' | cxTranslate }}</span>
      } @if (item?.product?.stock?.stockLevelStatus === 'discontinued') {
      <span class="discontinued">
        {{ 'product.discontinued' | cxTranslate }}
      </span>
      } @if (pageId !== cartPageId && !isManualAllocationActive) { @switch (item?.backordered) { @case (true) {
      <span class="no-stock">
        {{ 'product.noStock' | cxTranslate }}
      </span>
      } @case (false) {
      <span class="in-stock">
        {{ 'product.inStock' | cxTranslate }}
      </span>
      } } }
    </div>
    <!-- name -->
    @if (item.product.name) {
    <div class="product-name">
      @if (pageId === cartPageId) {
      <a
        class="cx-link"
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        (click)="viewItem()"
        [innerHTML]="item.product.name"
      >
      </a>
      } @if (pageId !== cartPageId) {
      <span [innerHTML]="item.product.name"> </span>
      }
    </div>
    }
    <!-- options -->
    @if (item?.variantInfo) {
    <div class="global-variant" [class.product-variant-info]="pageId !== cartPageId">
      @for (variant of checkVariant(item?.variantInfo); track variant; let index = $index; let last = $last) { @if
      (!last) {
      {{ variant.parentCategoryName }}: {{ variant.name }}; } @else { {{ variant.parentCategoryName }}:
      {{ variant.name }}
      } }
    </div>
    }
    <!-- In ticket GB2B-26444, this is to display JAN code on the Japan site only -->
    @if (janCodeEnabled && pageId === cartPageId) {
    <div class="jan-code">
      <div class="label">
        {{ 'cart.cartItem.jan' | cxTranslate }}
        @if (item.product?.jan || item.product?.ean) {
        <span class="attr-value">
          {{ item.product?.jan || item.product?.ean }}
        </span>
        }
      </div>
    </div>
    }
  </div>
  <!-- Item Price -->
  @if (item.basePrice && pageId === cartPageId) {
  <div class="price">
    <div class="label">
      {{ 'cart.cartItem.itemPrice' | cxTranslate }}
    </div>
    <ng-container>
      @if (item.basePrice && !showSrp) {
      <div
        class="value"
        [ngClass]="{
          'promo-version':
            (item.product.potentialPromotions && item.product.potentialPromotions.length > 0) ||
            (item.promotionMessage && item.promotionMessage !== '')
        }"
      >
        @if (!dealerSpinner) { @if (item.updateable && item.totalPrice.value > 0) {
        {{ item.basePrice?.formattedValue }}
        @if (item.basePrice?.formattedValue && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        }
        <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
        } @else {
        {{ item.totalPrice.formattedValue }}
        @if (item.totalPrice.formattedValue && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
        }
        <app-erp-promotional-text [product]="item"></app-erp-promotional-text>
        } } @else {
        <div class="spinner-shimano-wrapper">
          <div class="spinner-shimano">
            <div></div>
          </div>
        </div>
        }
      </div>
      }
    </ng-container>
  </div>
  }
  <!-- Item Quantity -->
  <div class="quantity">
    <cx-item-counter
      [control]="quantityControl"
      [readonly]="isReadOnlyInput(pageId, noStockError, item.updateable, item?.unavailableInB2B, unapprovedError)"
      [max]="999"
      [allowZero]="false"
      [itemCode]="item.product.code"
      (keypress)="numberOnly($event)"
      [moq]="minOrderQuantity"
      [isMinQty]="isMinQty"
    >
    </cx-item-counter>
  </div>
  <!-- Total -->
  @if (item.totalPrice) {
  <div class="total">
    <div class="label">{{ 'cart.cartItem.total' | cxTranslate }}</div>
    <ng-container>
      @if (pageId === 'Checkout' || !showSrp) {
      <div
        class="value"
        [class.discounted]="
          isDiscounted(item.totalPrice.value, item.basePrice?.value, item.quantity, appliedPromotions)
        "
      >
        {{ item.totalPrice.formattedValue }}
        @if (item.totalPrice.formattedValue && showGstExclusive$ | async) {
        <span class="gst-label">{{ 'cart.cartItem.gstExclusive' | cxTranslate }}</span>
        }
      </div>
      }
    </ng-container>
  </div>
  }
  <!-- Action -->
  @if (pageId === cartPageId) {
  <div class="remove-btn">
    @if (item.updateable) {
    <button class="link" (click)="removeItem(item)" [disabled]="showSrp">
      <mat-icon
        matTooltip="{{ 'buttonTooltip.cart.deleteEntry' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="cart-delete-entry"
        aria-label="displays a tooltip in bottom"
        svgIcon="x-icon"
        [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
      ></mat-icon>
    </button>
    }
  </div>
  }

  <div class="memo">
    @if (shimanoMemoEnabled) {
    <app-memo
      [memoControl]="memoControl"
      [readonly]="isMemoEnabled(noStockError)"
      [isMemoValid]="isMemoValid"
      [isInputValid]="isInputValid"
      [isLimitValid]="isLimitValid"
    ></app-memo>
    }
  </div>

  @if (pageId === cartPageId) {
  <div class="lead-time delivery-timeline">
    @if (showWarehouseFeature) { @if ( item.product?.stock.stockLevelStatus === 'backorder' &&
    item.product?.stock.stockLevel === 0 && item.product?.monthLeadTime ) {
    <div class="label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</div>
    <div class="value">{{ item.product?.monthLeadTime }}</div>
    } } @else { @if (item.product?.leadTime) { @if (item.product?.stock.stockLevelStatus !== 'outOfStock') {
    <div class="label">
      {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
    </div>
    } @if (item.product?.stock.stockLevelStatus === 'inStock') {
    <div class="value">
      {{ 'cart.cartItem.leadtime.value.instock' | cxTranslate : { time: item.product?.leadTime } }}
      {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
    </div>
    } @if (item.product?.stock.stockLevelStatus === 'backorder') {
    <div class="value">
      {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item.product?.leadTime } }}
      {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
    </div>
    } } }
  </div>
  } @if (pageId !== cartPageId) {
  <div class="lead-time delivery-timeline">
    @if (showWarehouseFeature) { @if (item?.backordered && item?.inventoryLeadTime) {
    <div>
      <span class="label lead-time-label">{{ 'cart.cartItem.dateLeadTime.title' | cxTranslate }}</span>
      <span class="value lead-time-value">{{ item?.inventoryLeadTime }}</span>
    </div>
    } } @else { @if (!item.backordered && item?.deliveryDate) {
    <div
      class="value"
      [innerHTML]="
        'cart.cartItem.delivery.value.instock' | cxTranslate : { time: item?.deliveryDate | date : dateFormatted }
      "
    ></div>
    } @else { @if (!item.backordered && checkLeadTime(item?.inventoryLeadTime)) {
    <div class="value lead-time-label">
      <span class="label lead-time-label">
        {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
      </span>
      {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item?.inventoryLeadTime } }}
      {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
    </div>
    } @if (item.backordered && checkLeadTime(item?.inventoryLeadTime)) {
    <div class="value lead-time-label">
      <span class="label lead-time-label">
        {{ 'cart.cartItem.leadtime.title' | cxTranslate }}
      </span>
      {{ 'cart.cartItem.leadtime.value.backorder' | cxTranslate : { time: item?.inventoryLeadTime } }}
      {{ 'cart.cartItem.leadtime.value.day' | cxTranslate }}
    </div>
    } } }
  </div>
  } @if (pageId === cartPageId && !showSrp) {
  <div class="promotional-text" [ngClass]="shimanoMemoEnabled ? '' : 'noMemo'">
    <app-promotional-text
      [product]="item.product"
      [appliedProductPromotions]="appliedPromotions"
      [promotionLocation]="promotionLocation"
      [cartItem]="item"
      [orderEntryNumber]="item.entryNumber"
      [hasMemoField]="shimanoMemoEnabled ? 'true' : 'false'"
    ></app-promotional-text>
  </div>
  }
</div>
